import { Snackbar } from '@mui/material';
import SnackbarContent from '@mui/material/SnackbarContent';
import { styled } from '@mui/material/styles';

import ColormapInterface from 'shared-types/colormapinterface';
import { borderRadius } from 'stylesheetB2b';
import { getSpacing } from 'stylesheetB2c';

export const Content = styled(SnackbarContent)<{ colors: ColormapInterface }>(({ colors }) => ({
  borderRadius: borderRadius.XLarge,
  backgroundColor: colors.confirmationSnackbarBackground,
  '& .MuiSnackbarContent-message': {
    fontFamily: 'Roboto',
    width: '100%',
    textAlign: 'center',
  },
}));

export const Container = styled(Snackbar)({
  marginTop: getSpacing(2),
});
